/* eslint-disable indent */
import EntryGrid from 'components/Inputs/EntryGrid';
import TextBox from 'components/Inputs/TextBox';
import React from 'react';
import SelectBox from 'components/SelectBox';
import { Row, Col, Button, FormGroup } from 'reactstrap';
import DatePicker from 'components/Inputs/DatePicker';
import { t } from 'i18next';
import * as PaymentTypeAction from 'store/actions/payment_type';
import { useDispatch, useSelector } from 'react-redux';

function BasicInfoForm({
  register,
  errors,
  control,
  editData,
  setValue,
  watch,
  getValues,
  onFetchInvoiceNumber,
  onSelectDepositInvoice,
  // onSelectOrder,
  selectedOrder,
  selectedAddress,
}) {




  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(PaymentTypeAction.getAll({}));
  }, [PaymentTypeAction.getAll, dispatch]);

  const payment_types = useSelector((state) => state.other_maintenance.payment_types);
  const paymentTypeOptions = payment_types?.map((e) => {
    return {
      label: e.name,
      value: e._id,
    };
  });


  return (
    <EntryGrid title={`${t('commercial_invoice.commercial_invoice')} `}>
      <Row className='pt-1 pb-1'>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>{t('commercial_invoice.invoice_number')}</label>
            <div className='d-flex'>
              <div style={{ flex: 1 }}>
                <TextBox
                  className='form-control mr-2'
                  type='text'
                  registerProps={register('basicinfo.invoice_no', {
                    required: `${t('commercial_invoice.invoice_number')} ${t('is_required')}`,
                  })}
                  errors={errors?.basicinfo?.waybill_no}
                  disabled={editData}
                />
              </div>
              <Button
                color='success'
                type='button'
                size='sm'
                style={{ maxHeight: 35 }}
                onClick={() => onFetchInvoiceNumber()}
                disabled={editData || selectedOrder}
              >
                <i className='fa fa-plus text-white'></i>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>{t('commercial_invoice.ref_no')}</label>
            <div className='d-flex'>
              <div style={{ flex: 1 }}>
                <TextBox
                  className='form-control mr-2'
                  type='text'
                  registerProps={register('basicinfo.ref_no')}
                  errors={errors?.basicinfo?.ref_no}
                  disabled={true}
                />
              </div>
              <Button
                color='primary'
                type='button'
                size='sm'
                style={{ maxHeight: 35 }}
                onClick={() => onSelectDepositInvoice && onSelectDepositInvoice()}
              >
                <i className='fa fa-search text-white'></i>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>{t('commercial_invoice.license_no')}</label>
            <TextBox
              className='form-control mr-2'
              type='text'
              registerProps={register('basicinfo.license_no')}
              errors={errors?.basicinfo?.license_no}
            />
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>{t('deposit_invoice.quotation_no')}</label>
            <TextBox
              className='form-control mr-2'
              type='text'
              registerProps={register('basicinfo.quotation_no')}
              errors={errors?.iteminfo?.itemname}
              disabled={true}
            />
          </FormGroup>
        </Col>
        <Col md={2} sm={6} xs={12}>
          <FormGroup>
            <label>Currency</label>
            <SelectBox
              label='Currency'
              control={control}
              name='basicinfo.currency'
              options={[
                { label: 'MMK', value: 'MMK' },
                { label: 'USD', value: 'USD' },
                { label: 'THB', value: 'THB' },
              ]}
            />
          </FormGroup>
        </Col>




        <Col md={2} sm={6} xs={12}>
          <FormGroup>
            <label>{t('waybill_entry.sale_person')}</label>

            <TextBox
              value={
                selectedAddress
                  ? selectedAddress?.marketing_person?.name
                  : selectedOrder
                    ? selectedOrder?.sale_person?.name
                    : editData?.sale_person?.name
              }
              disabled
            />
          </FormGroup>
        </Col>
        <Col md={2} sm={6} xs={12}>
          <FormGroup>
            <label>{t('commercial_invoice.invoice_date')}</label>
            <DatePicker
              onChange={(date) => {
                setValue('basicinfo.invoice_date', date);
              }}
              initialValue={getValues('basicinfo.invoice_date')}
            />
          </FormGroup>
        </Col>
        <Col md={2} sm={6} xs={12}>
          <FormGroup>
            <label>{t('waybill_entry.destination')}</label>

            <TextBox
              value={
                selectedAddress
                  ? selectedAddress?.branch?.name : ""
              }
              disabled
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className='pt-1 pb-1'>
        <Col md={12}>
          <FormGroup>
            <label>Remarks</label>
            <TextBox
              className='form-control'
              type='text'
              registerProps={register('basicinfo.remark')}
              errors={errors?.basicinfo?.remark}
              placeholder='Enter any additional remarks here'
            />
          </FormGroup>
        </Col>
      </Row>
    </EntryGrid>
  );
}
export default BasicInfoForm;
